import React, { useState } from 'react';
import './Contact.css';

// Initialise empty variables
function ContactForm() {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    message: '',
  });

  const [submitted, setSubmitted] = useState(false);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  //   Establish valid email format
  const isValidEmail = (email) => {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return emailPattern.test(email);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!formData.username) {
      window.alert("Please enter your name.");
      return;
    }

    if (!formData.email) {
      window.alert("Please enter your email address.");
      return;
    }


    // Valid email check
    if (!isValidEmail(formData.email)) {
      window.alert("Please enter a valid email address.");
      return;
    }
    if (!formData.message) {
      window.alert("Please enter your message.");
      return;
    }

    // Send the form data to your backend 

    fetch("https://formsubmit.co/ajax/aethelsongs@gmail.com", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        name: formData.username,
        email: formData.email,
        message: formData.message
      })
    })
      .then(response => {
        if (response.ok) {
          // Display success message
          window.alert("Your details have been sent!");
          // Optionally, clear the form data after successful submission
          setFormData({
            username: '',
            email: '',
            message: '',
          });
          setSubmitted(true);

          // Automatically hide the message after 3000 milliseconds (3 seconds)
          setTimeout(() => {
            setSubmitted(false);
          }, 3000);
        } else {
          throw new Error('Network response was not ok.');
        }
      })
      .catch(error => {
        // Handle errors
        console.error('Error:', error);
        window.alert("An error occurred while submitting the form. Please try again later.");
      });
  };

  return (
    <div className="Contact-form">

      <form id='Contact Form' onSubmit={handleSubmit}>
        <input type='hidden' name='subject' value='New Message!'></input>
        <div><label htmlFor='username'></label>
          <input type='text' id='username' name='username' placeholder='Name' value={formData.username}
            onChange={handleInputChange}></input></div>
        <div><label htmlFor='email'></label>
          <input type='text' id='email' placeholder='Email' name='email' value={formData.email}
            onChange={handleInputChange}></input></div>
        <div><label htmlFor='message'></label>
          <textarea type='text' id='message' placeholder='Message' name='message' value={formData.message}
            onChange={handleInputChange}></textarea></div>
        <button type='submit' id='Submit' onClick={handleSubmit}>Submit</button>
      </form>
      {submitted && (
        <p>Your details have been sent!</p>
      )}
    </div>
  );
}

export default ContactForm;

